import { ArrowUpRight } from "lucide-react";
import { CONTACT_URL, TALLY_FORM_ID } from "@/lib/content";

const styles = {
  dark: "bg-[#221e1b] text-[#faf5ee] hover:bg-[#3a322c]",
  outline: "border border-[#221e1b]/25 text-[#221e1b] hover:border-[#a8792a] hover:text-[#7a5615]",
};

const sizes = {
  default: "px-6 py-3 text-sm",
  large: "px-7 py-3.5 text-base",
};

export const ContactButton = ({ testId, label = "Get in Touch", variant = "dark", size = "default", className = "" }) => {
  const Element = TALLY_FORM_ID ? "a" : "button";
  const openForm = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.Tally?.openPopup) return;
    event.preventDefault();
    const trigger = event.currentTarget;
    window.Tally.openPopup(TALLY_FORM_ID, {
      layout: "modal",
      width: 520,
      alignLeft: true,
      hideTitle: true,
      overlay: true,
      onClose: () => { if (trigger.isConnected) trigger.focus(); },
    });
  };
  const actionProps = TALLY_FORM_ID
    ? { href: CONTACT_URL, target: "_blank", rel: "noopener noreferrer", onClick: openForm, "aria-haspopup": "dialog" }
    : { type: "button", disabled: true, title: "Contact will be available soon" };

  return (
    <Element
      {...actionProps}
      data-testid={testId}
      className={`group inline-flex items-center gap-2 rounded-full font-semibold tracking-wide transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7a5615] disabled:cursor-not-allowed disabled:opacity-60 ${sizes[size]} ${styles[variant]} ${className}`}
    >
      {label}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </Element>
  );
};
